<template>
  <div class="BarStream">
    <div class="status hover">
      <button @click="onAudioClick">
        <span :class="getIcon"></span><span>{{ getOnAir }}</span>
      </button>
    </div>
    <div class="title">
      <marquee-conditional :content="getTitle" />
    </div>
    <div class="spacer"></div>
  </div>
</template>

<script>
import MarqueeConditional from "./MarqueeConditional";

export default {
  name: "BarStream",
  components: { MarqueeConditional },
  props: {
    timeVisible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onAudioClick() {
      this.$store.dispatch("toggleStream");
    },
  },
  computed: {
    getOnAir() {
      if (this.stream.paused) {
        return "Tune In";
      } else {
        return "On Air";
      }
    },
    getTitle() {
      return this.stream.loaded ? this.stream.combo : "Loading…";
    },

    stream() {
      return this.$store.state.audio.stream;
    },
    getIcon() {
      return this.$store.state.audio.stream.paused
        ? "icon-player-play"
        : "icon-player-stop";
    },
    date() {
      return this.$store.state.date.local;
    },
  },
};
</script>

<style scoped>
.BarStream {
  display: flex;
  white-space: nowrap;
  position: relative;
  width: 100%;
  height: 35px;
  align-items: center;
  float: left;
  justify-content: space-between;
  overflow: hidden;
}

.title {
  display: flex;
  text-align: center;
  padding: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}

.title::before,
.title::after {
  content: "";
  display: block;

  height: 100%;
  position: absolute;
  top: 0;

  z-index: 1;
  background: transparent;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.title::after {
  right: 20rem;
  left: auto;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}

.title >>> .inner {
  padding-left: 1rem;
  padding-right: 1rem;
}

.time {
  margin-left: auto;
}

.status {
  margin-right: 2rem;
  position: relative;
  z-index: 2;
}

.status [class*="icon-player"] {
  display: inline-block;
  font-size: 0.75em;
  margin-right: 2rem;
  margin-left: 2rem;
}

@media (max-width: 1000px) {
  .status [class*="icon-player"] {
    margin-right: 1rem;
  }

  .status span:last-child {
    display: none;
  }

  .marquee-container a {
    display: none;
  }

  .time {
    padding-left: 2rem;
  }

  .title {
    position: relative;

    padding: 0;
    text-align: left;
    flex: 1;
  }

  .title::before {
    left: 0;
  }

  .title::after {
    right: 0;
  }
}
</style>

<style>
@media screen and (max-width: 1000px) {
  div.HeaderWrap
    > div.Header.mobile
    > div.mobile-bar
    > div
    > div.title
    > div
    > div.marquee-container
    > a
    > button {
    display: none !important;
  }
}
</style>
